import { render, staticRenderFns } from "./AmostrasFormRecebimentoLaboratorioGuarulhos.vue?vue&type=template&id=679e55f9&"
import script from "./AmostrasFormRecebimentoLaboratorioGuarulhos.vue?vue&type=script&lang=ts&"
export * from "./AmostrasFormRecebimentoLaboratorioGuarulhos.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VDivider,VForm,VIcon,VRow})
